module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0MyA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yNC4wNjIxIDIyLjI0NDFMNDIuNTAwMiAzLjU1NTFMMzkuNjg3NyAwLjc0MjU5NkwyMS4yMTg0IDE5LjQwMDNMMy42MjQ2MiAwLjgzNzgzM0wwLjgxMjEyNCAzLjY1MDMzTDE4LjM3NDYgMjIuMjQ0MUwwLjU0ODM0IDQwLjMzNkwzLjM2MDg0IDQzLjE0ODVMMjEuMjE4NCAyNS4wODc4TDM5LjYzOTkgNDMuNDIwMkw0Mi40NTI0IDQwLjYwNzdMMjQuMDYyMSAyMi4yNDQxWiIgZmlsbD0iYmxhY2siLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/x.svg
// module id = +08w
// module chunks = 0